import Vue, { PluginFunction, PluginObject } from 'vue';
// Specify a file with the types you want to augment
// Vue has the constructor type in types/vue.d.ts
declare module 'vue/types/vue' {
    // 3. Declare augmentation for Vue
    interface Vue {
        $dateUtils: DateUtils;
    }
}

export interface DateUtilsOption {}

export class DateUtils implements PluginObject<DateUtilsOption> {

	/**
	 * date to dateStr yyyy-MM-dd
	 * @param date
	 * @returns date str
	 */
	public convertDate2DateStr(date: Date) {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		const localDate = `${year}-${month}-${day}`;
		return localDate;
	}

    private vue: Vue;

    public install(Vue, options: DateUtilsOption) {
		console.log('date utils installed');
		Vue.prototype.$dateUtils = this;
    }
}
export default new DateUtils();
